import * as React from 'react';

import classnames from 'classnames';

import {AttachmentList} from '../attachment-list/attachment-list';
import {IconButton} from '../button/icon-button/icon-button';
import {Dialog} from '../dialog/dialog';
// @ts-expect-error - imported from .js/.jsx file
import {DownloadIcon} from '../icon/svg/download-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from '../icon/svg/eye-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeSlashIcon} from '../icon/svg/eye-slash-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyAllIcon} from '../icon/svg/reply-all-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyIcon} from '../icon/svg/reply-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from '../icon/svg/trash-icon';
import {Popover} from '../popover/popover';

import styles from './modal-toolbar.module.css';

type Props = {
    onConfirmDelete: (e: React.SyntheticEvent<any>) => void;
    onClickHide: (e: React.SyntheticEvent<any>) => void;
    attachments?: Array<any>;
    isShared: boolean;
    isShareable: boolean;
    replyOptions?: {
        onClickReplyAll: (e: React.SyntheticEvent<any>) => void;
        onClickReply: (e: React.SyntheticEvent<any>) => void;
    };
};

export function ModalToolbar(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const [isViewingAttachments, setIsViewingAttachments] = React.useState<boolean>(false);

    const deleteButtonRef = React.useRef(null);
    const attachmentsButtonRef = React.useRef(null);

    const sharingIcons = props.isShared ? (
        <IconButton icon={EyeSlashIcon} text='Hide' onClick={props.onClickHide} />
    ) : (
        <IconButton icon={EyeIcon} text='Unhide' onClick={props.onClickHide} />
    );

    return (
        <div className={classnames('flex full-width', styles['modal-toolbar'])}>
            <div>
                <IconButton
                    icon={TrashIcon}
                    text='Delete'
                    onClick={() => setIsConfirmingDelete(true)}
                    getButtonRef={deleteButtonRef}
                    variant='danger'
                />
                {props.isShareable ? sharingIcons : undefined}
                {props.attachments && props.attachments.length ? (
                    <IconButton
                        icon={DownloadIcon}
                        text='Attachments'
                        getButtonRef={attachmentsButtonRef}
                        onClick={() => setIsViewingAttachments(true)}
                    />
                ) : undefined}
            </div>
            {props.replyOptions ? (
                <div>
                    <IconButton
                        icon={ReplyAllIcon}
                        text='Reply all'
                        onClick={props.replyOptions.onClickReplyAll}
                    />
                    <IconButton
                        icon={ReplyIcon}
                        text='Reply'
                        onClick={props.replyOptions.onClickReply}
                    />
                </div>
            ) : undefined}
            {isViewingAttachments ? (
                <Popover
                    anchor={attachmentsButtonRef.current}
                    onBlur={(e) => {
                        e.stopPropagation();
                        setIsViewingAttachments(false);
                    }}
                >
                    {props.attachments ? (
                        <AttachmentList attachments={props.attachments} />
                    ) : undefined}
                </Popover>
            ) : undefined}
            {isConfirmingDelete ? (
                <Dialog
                    anchor={deleteButtonRef.current}
                    question={`Are you sure you want to delete this ${
                        props.replyOptions ? 'email' : ''
                    }?`}
                    primaryText={`Yes, delete ${props.replyOptions ? 'email' : ''}`}
                    secondaryText='No, don’t delete'
                    onPrimary={props.onConfirmDelete}
                    onSecondary={() => setIsConfirmingDelete(false)}
                    isWarning={true}
                />
            ) : undefined}
        </div>
    );
}
